import * as actions from './actions';

export default {
  strict: true,
  state: {
    isFetchingWaivers: false,
  },
  actions,
};
